import ErrorCodes from '@/constants/error-codes'
import PaymentTypes from '@/constants/payment-types'

const ERROR_MESSAGE_TABLE = {
  [ErrorCodes.UNKNOWN]: {
    title: 'order_finish_declined_unknown_title',
    subtitle: 'order_finish_declined_unknown_sub_title',
  },
  [ErrorCodes.REACHED_CREDIT_LIMIT]: {
    title: 'order_finish_declined_reached_credit_limit_title',
    subtitle: 'order_finish_declined_reached_credit_limit_sub_title',
  },
  [ErrorCodes.NOT_PAID_OVERDUE]: {
    title: 'instalment_finish_declined_not_paid_overdue_title',
    subtitle: 'instalment_finish_declined_not_paid_overdue_sub_title',
  },
  [ErrorCodes.REACHED_DOWN_PAYMENT_THRESHOLD]: {
    title: 'instalment_finish_declined_reached_down_payment_title',
    subtitle: 'instalment_finish_declined_reached_down_payment_subtitle',
  },
  [ErrorCodes.ID_USED_BY_ANOTHER_ACCOUNT]: {
    title: 'instalment_finish_declined_id_used_by_another_acc_title',
    subtitle: 'instalment_finish_declined_id_used_by_another_acc_subtitle',
  },
  [ErrorCodes.POOR_CREDIT_SCORE]: {
    title: 'instalment_finish_declined_poor_credit_score_title',
    subtitle: 'instalment_finish_declined_poor_credit_score_subtitle',
  },
  [ErrorCodes.NUMBER_IS_BLACKLIST]: {
    title: 'instalment_finish_declined_number_is_blacklist_title',
    subtitle: 'instalment_finish_declined_number_is_blacklist_sub_title',
  },
  [ErrorCodes.VPN_USED]: {
    title: 'instalment_finish_declined_vpn_used_title',
    subtitle: 'instalment_finish_declined_vpn_used_sub_title',
  },
  [ErrorCodes.FIRST_PAYMENT_IS_NOT_PAID]: {
    title: 'instalment_finish_declined_first_payment_is_not_paid_title',
    subtitle: 'instalment_finish_declined_first_payment_is_not_paid_sub_title',
  },
  [ErrorCodes.MULTIPLE_ACCOUNTS]: {
    title: 'instalment_finish_declined_multiple_accounts_title',
    subtitle: 'instalment_finish_declined_multiple_accounts_sub_title',
  },
  [ErrorCodes.BLACKLIST_PHONE_NUMBER]: {
    title: 'instalment_finish_declined_multiple_accounts_title',
    subtitle: 'instalment_finish_declined_multiple_accounts_sub_title',
  },
  [ErrorCodes.EXCEED_ELM_RETRIES]: {
    title: 'instalment_finish_declined_exceed_elm_retries_title',
    subtitle: 'instalment_finish_declined_exceed_elm_retries_sub_title',
  },
  [ErrorCodes.NOT_ENOUGH_AGE]: {
    title: 'order_finish_declined_not_enough_age_title',
    subtitle: 'order_finish_declined_not_enough_age_sub_title',
  },
  [ErrorCodes.MATURE_REACHED_CREDIT_LIMIT]: {
    title: 'order_finish_declined_mature_reached_credit_limit_title',
    subtitle: 'order_finish_declined_mature_reached_credit_limit_sub_title',
  },
  [ErrorCodes.EXCEED_SANCTION_LIST_THRESHOLD]: {
    title: 'order_finish_declined_exceed_sanction_list_threshold_title',
    subtitle: 'order_finish_declined_exceed_sanction_list_threshold_sub_title',
  },
  [ErrorCodes.ITEM_VIOLATED]: {
    title: 'order_finish_declined_item_violated_title',
    subtitle: 'order_finish_declined_item_violated_sub_title',
  },
  [ErrorCodes.SKU_BLOCKED]: {
    title: 'order_finish_declined_sku_blocked_title',
    subtitle: 'order_finish_declined_sku_blocked_sub_title',
  },
  [ErrorCodes.INVALID_RESIDENT_STATUS]: {
    title: 'rejected_by_invalid_resident_status_title',
    subtitle: 'rejected_by_invalid_resident_status_sub_title',
  },
  [ErrorCodes.DECLINED_D_DO_NOT_HONOUR]: {
    title: '',
    subtitle: 'instalment_finish_declined_d_do_not_honour_sub_title',
  },
  [ErrorCodes.INSUFFICIENT_FUNDS]: {
    title: '',
    subtitle: 'instalment_finish_declined_insufficient_funds_sub_title',
  },
  [ErrorCodes.EXPIRED_CARD]: {
    title: '',
    subtitle: 'instalment_finish_declined_expired_card',
  },
  [ErrorCodes.YOUTH_REACHED_CREDIT_LIMIT]: {
    title: 'order_finish_declined_youth_reached_credit_limit_title',
    subtitle: 'order_finish_declined_youth_reached_credit_limit_sub_title',
  },
  [ErrorCodes.SYSTEM_3DS_MALFUNCTION]: {
    title: '',
    subtitle: 'instalment_finish_declined_sys_3ds_malfunction',
  },
  [`${ErrorCodes.REJECTED_BASED_ON_SIMAH_SCORE}_${PaymentTypes.PAY_BY_LATER}`]:
    {
      title: '',
      subtitle: 'pay_later_finish_declined_based_on_simah_score_sub_title',
    },
  [`${ErrorCodes.REJECTED_BASED_ON_SIMAH_SCORE}_${PaymentTypes.PAY_BY_INSTALMENTS}`]:
    {
      title: '',
      subtitle: 'instalment_finish_declined_based_on_simah_score_sub_title',
    },
  [`${ErrorCodes.REJECTED_BASED_ON_SIMAH_SCORE}_${PaymentTypes.PAY_NEXT_MONTH}`]:
    {
      title: '',
      subtitle: 'pay_next_month_finish_declined_based_on_simah_score_sub_title',
    },
  [ErrorCodes.BLACKLIST_ITEM]: {
    title: '',
    subtitle: 'instalment_finish_declined_blacklist_item_sub_title',
  },
  [ErrorCodes.MISSING_ID_NUMBER]: {
    title: '',
    subtitle: 'signzy_error_missing_id_number',
  },
  [ErrorCodes.PAYMENT_OPTIONS_NOT_AVAILABLE]: {
    title: 'payment_link_payment_options_not_available_title',
    subtitle: 'payment_link_payment_options_not_available_subtitle',
  },
  [ErrorCodes.SEON_DECLINED_ORDER]: {
    title: '',
    subtitle: 'seon_declined_order',
  },
  [ErrorCodes.CREDIT_LIMIT_BY_PASSING_FRAUD_VIOLATION]: {
    title: 'finish_declined_credit_limit_by_passing_fraud_violation_title',
    subtitle:
      'finish_declined_credit_limit_by_passing_fraud_violation_sub_title',
  },
  [ErrorCodes.ORDER_VALUE_BEYOND_LIMIT]: {
    title: 'finish_declined_order_value_beyond_limit_title',
    subtitle: 'finish_declined_order_value_beyond_limit_sub_title',
  },
  [ErrorCodes.USER_IS_UNDERAGE]: {
    title: 'user_is_underage_error_title',
    subtitle: 'user_is_underage_error_msg',
  },
  [ErrorCodes.NAFATH_WAS_REJECTED]: {
    title: 'finish_declined_nafath_rejected_id_title',
    subtitle: 'finish_declined_nafath_rejected_id_sub_title',
  },
  [ErrorCodes.NAFATH_EXCEED_MAX_ATTEMPT]: {
    title: 'finish_declined_nafath_exceed_max_attempt_title',
    subtitle: 'finish_declined_nafath_exceed_max_attempt_sub_title',
  },
  [ErrorCodes.NAFATH_REQUEST_STILL_ACTIVE]: {
    title: 'finish_declined_nafath_request_still_active_title',
    subtitle: 'finish_declined_nafath_request_still_active_sub_title',
  },
  // LeanTech errors
  [ErrorCodes.LEAN_MAX_ATTEMPTS_EXCEEDED]: {
    title: 'lean_tech_flow_max_attempts_exceeded_title',
    subtitle: 'lean_tech_flow_max_attempts_exceeded_subtitle',
  },
  [ErrorCodes.LEAN_SESSION_EXPIRED]: {
    title: 'lean_tech_flow_session_expired_title',
    subtitle: 'lean_tech_flow_session_expired_subtitle',
  },
  [ErrorCodes.LEAN_ACCOUNT_DUPLICATED]: {
    title: 'lean_tech_flow_account_duplicated_title',
    subtitle: 'lean_tech_flow_account_duplicated_subtitle',
  },
  [ErrorCodes.LEAN_ACCOUNT_MISMATCH]: {
    title: 'lean_tech_flow_account_mismatch_title',
    subtitle: 'lean_tech_flow_account_mismatch_subtitle',
  },

  // Uqudo errors
  [ErrorCodes.UQUDO_MISSING_IDENTITY_DOCUMENT]: {
    title: 'uqudo_flow_general_error_title',
    subtitle: 'uqudo_flow_general_error_subtitle',
  },
  [ErrorCodes.UQUDO_DOCUMENT_NOT_VERIFIED]: {
    title: 'uqudo_flow_general_error_title',
    subtitle: 'uqudo_flow_general_error_subtitle',
  },
  [ErrorCodes.UQUDO_MISSING_IDENTITY_NUMBER]: {
    title: 'uqudo_flow_general_error_title',
    subtitle: 'uqudo_flow_general_error_subtitle',
  },
  [ErrorCodes.UQUDO_IDENTITY_NUMBER_ALREADY_EXIST]: {
    title: 'uqudo_flow_id_already_in_use_title',
    subtitle: 'uqudo_flow_id_already_in_use_sub_title',
  },
  [ErrorCodes.UQUDO_INVALID_TOKEN_SIGNATURE]: {
    title: 'uqudo_invalid_token_signature_title',
    subtitle: 'uqudo_invalid_token_signature_subtitle',
  },
  [ErrorCodes.UQUDO_EXPIRED_TOKEN]: {
    title: 'uqudo_flow_general_error_title',
    subtitle: 'uqudo_flow_general_error_subtitle',
  },
  [ErrorCodes.UQUDO_FACIAL_THRESHOLD]: {
    title: 'uqudo_flow_facial_threshhold_title',
    subtitle: 'uqudo_flow_facial_threshold_subtitle',
  },
  [ErrorCodes.UQUDO_RETRY_LIMITED]: {
    title: 'uqudo_flow_general_error_title',
    subtitle: 'uqudo_flow_general_error_subtitle',
  },
  [ErrorCodes.UQUDO_FACE_ALREADY_MATCHED_FOR_ANOTHER_ID]: {
    title: 'uqudo_flow_general_error_title',
    subtitle: 'uqudo_flow_general_error_subtitle',
  },
  [ErrorCodes.UQUDO_RE_VERIFICATION_NATIONAL_ID_MISMATCH]: {
    title: 'uqudo_flow_general_error_title',
    subtitle: 'uqudo_flow_general_error_subtitle',
  },
  [ErrorCodes.UQUDO_RE_VERIFICATION_DOB_MISMATCH]: {
    title: 'uqudo_flow_general_error_title',
    subtitle: 'uqudo_flow_general_error_subtitle',
  },
  [ErrorCodes.UQUDO_NATIONAL_ID_NUMBER_INVALID]: {
    title: 'uqudo_flow_national_id_number_invalid_error_title',
    subtitle: 'uqudo_flow_national_id_number_invalid_error_subtitle',
  },
  // Uae kyc errors
  [ErrorCodes.UAE_KYC_GENERIC_MESSAGE]: {
    title: 'uae_kyc_journey_error',
    subtitle: 'uae_kyc_journey_error_message',
  },
  [ErrorCodes.UAE_KYC_ID_EXPIRED]: {
    title: 'uae_kyc_journey_id_expired',
    subtitle: 'uae_kyc_journey_id_expired_message',
  },
  [ErrorCodes.UAE_KYC_ID_VERIFICATION_FAILED]: {
    title: 'uae_kyc_journey_id_verification_failed',
    subtitle: 'uae_kyc_journey_id_verification_failed_message',
  },
  [ErrorCodes.UAE_KYC_ID_VERIFICATION_INCOMPLETE]: {
    title: 'uae_kyc_journey_id_verification_incomplete',
    subtitle: 'uae_kyc_journey_id_verification_incomplete_message',
  },
  // Checkout errors
  [ErrorCodes.CHECKOUT_REPAYMENT_SERVICE_DISABLED]: {
    title: '',
    subtitle: 'checkout_repayment_service_disabled',
  },
  [ErrorCodes.ISSUER_OR_SWITCH_IS_INOPERATIVE]: {
    title: 'payment_errors.issuer_or_switch_is_inoperative.message',
    subtitle: '',
  },
  [ErrorCodes.CARDHOLDER_FAILED_3D_SECURE_AUTHENTICATION]: {
    title: 'payment_errors.cardholder_failed_3d_secure_authentication.message',
    subtitle: '',
  },
  [ErrorCodes.INVALID_CARD_NUMBER]: {
    title: 'payment_errors.invalid_card_number.message',
    subtitle: '',
  },
  [ErrorCodes.CVV2_FAILURE]: {
    title: 'payment_errors.decline_cvv_failure.message',
    subtitle: '',
  },
  [ErrorCodes.CLOSED_ACCOUNT]: {
    title: 'payment_errors.closed_account.message',
    subtitle: '',
  },
  [ErrorCodes.TRANSACTION_NOT_PERMITTED_TO_CARDHOLDER]: {
    title: 'payment_errors.transaction_not_permitted_to_cardholder.message',
    subtitle: '',
  },
  [ErrorCodes.INVALID_VALUE_AMOUNT]: {
    title: 'payment_errors.invalid_amount.message',
    subtitle: '',
  },
}

export const ERROR_MESSAGE_TABLE_V2 = {
  default: {
    title: 'payment_errors.default.title',
    subtitle: 'payment_errors.default.message',
    bannerText: 'payment_errors.default.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.default.banner_text.without_card_info',
  },
  [ErrorCodes.NUMBER_IS_BLACKLIST]: {
    title: 'payment_errors.blacklisted.title',
    subtitle: 'payment_errors.blacklisted.message',
    bannerText: 'payment_errors.blacklisted.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.number_is_blacklist.banner_text.without_card_info',
  },
  [ErrorCodes.SYSTEM_3DS_MALFUNCTION]: {
    title: 'payment_errors.cardholder_failed_3ds_auth.title',
    subtitle: 'payment_errors.cardholder_failed_3ds_auth.message',
    bannerText: 'payment_errors.cardholder_failed_3ds_auth.banner_text',
  },
  [ErrorCodes.INVALID_CARD_NUMBER]: {
    title: 'payment_errors.invalid_card_number.title',
    subtitle: 'payment_errors.invalid_card_number.message',
    bannerText: 'payment_errors.invalid_card_number.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.invalid_card_number.banner_text.without_card_info',
  },
  [ErrorCodes.DECLINED_D_DO_NOT_HONOUR]: {
    title: 'payment_errors.do_not_honour.title',
    subtitle: 'payment_errors.do_not_honour.message',
    bannerText: 'payment_errors.do_not_honour.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.declined_d_do_not_honour.banner_text.without_card_info',
  },
  [ErrorCodes.CVV2_FAILURE]: {
    title: 'payment_errors.cvv2_failure.title',
    subtitle: 'payment_errors.cvv2_failure.message',
    bannerText: 'payment_errors.cvv2_failure.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.cvv2_failure.banner_text.without_card_info',
  },
  [ErrorCodes.CLOSED_ACCOUNT]: {
    title: 'payment_errors.closed_account.title',
    subtitle: 'payment_errors.closed_account.message',
    bannerText: 'payment_errors.closed_account.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.closed_account.banner_text.without_card_info',
  },
  [ErrorCodes.TRANSACTION_NOT_PERMITTED_TO_CARDHOLDER]: {
    title: 'payment_errors.transaction_not_permitted_to_cardholder.title',
    subtitle: 'payment_errors.transaction_not_permitted_to_cardholder.message',
    bannerText:
      'payment_errors.transaction_not_permitted_to_cardholder.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.transaction_not_permitted_to_cardholder.banner_text.without_card_info',
  },
  [ErrorCodes.EXPIRED_CARD]: {
    title: 'payment_errors.expired_card.title',
    subtitle: 'payment_errors.expired_card.message',
    bannerText: 'payment_errors.expired_card.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.expired_card.banner_text.without_card_info',
  },
  [ErrorCodes.EXPIRED_CARD_STR]: {
    title: 'payment_errors.expired_card.title',
    subtitle: 'payment_errors.expired_card.message',
    bannerText: 'payment_errors.expired_card.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.expired_card.banner_text.without_card_info',
  },
  [ErrorCodes.DELINQUENT_CUSTOMER]: {
    title: 'payment_errors.delinquent_customer.title',
    subtitle: 'payment_errors.delinquent_customer.message',
    bannerText: 'payment_errors.delinquent_customer.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.delinquent_customer.banner_text.without_card_info',
  },
  [ErrorCodes.INVALID_VALUE_AMOUNT]: {
    title: 'payment_errors.invalid_value_amount.title',
    subtitle: 'payment_errors.invalid_value_amount.message',
    bannerText: 'payment_errors.invalid_value_amount.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.invalid_value_amount.banner_text.without_card_info',
  },
  [ErrorCodes.CARDHOLDER_FAILED_3D_SECURE_AUTHENTICATION]: {
    title: 'payment_errors.cardholder_failed_3ds_auth.title',
    subtitle: 'payment_errors.cardholder_failed_3ds_auth.message',
    bannerText: 'payment_errors.cardholder_failed_3ds_auth.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.cardholder_failed_3d_secure_authentication.banner_text.without_card_info',
  },
  [ErrorCodes.CARD_IS_PREPAID]: {
    title: 'payment_errors.card_is_prepaid.title',
    subtitle: 'payment_errors.card_is_prepaid.message',
    bannerText: 'payment_errors.card_is_prepaid.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.card_is_prepaid.banner_text.without_card_info',
  },
  [ErrorCodes.CARD_IS_PREPAID_2]: {
    title: 'payment_errors.card_is_prepaid.title',
    subtitle: 'payment_errors.card_is_prepaid.message',
    bannerText: 'payment_errors.card_is_prepaid.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.card_is_prepaid.banner_text.without_card_info',
  },
  [ErrorCodes.INSUFFICIENT_FUNDS]: {
    title: 'payment_errors.insufficient_funds.title',
    subtitle: 'payment_errors.insufficient_funds.message',
    bannerText: 'payment_errors.insufficient_funds.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.insufficient_funds.banner_text.without_card_info',
  },
  [ErrorCodes.SUSPECTED_FRAUD]: {
    title: 'payment_errors.suspected_fraud.title',
    subtitle: 'payment_errors.suspected_fraud.message',
    bannerText: 'payment_errors.suspected_fraud.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.suspected_fraud.banner_text.without_card_info',
  },
  [ErrorCodes.ISSUER_OR_SWITCH_IS_INOPERATIVE]: {
    title: 'payment_errors.issuer_or_switch_is_inoperative.title',
    subtitle: 'payment_errors.issuer_or_switch_is_inoperative.message',
    bannerText: 'payment_errors.issuer_or_switch_is_inoperative.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.issuer_or_switch_is_inoperative.banner_text.without_card_info',
  },
  [ErrorCodes.RESTRICTED_CARD]: {
    title: 'payment_errors.restricted_card.title',
    subtitle: 'payment_errors.restricted_card.message',
    bannerText: 'payment_errors.restricted_card.banner_text',
    bannerTextWithoutCardInfo:
      'payment_errors.restricted_card.banner_text.without_card_info',
  },
}

export default ERROR_MESSAGE_TABLE
